import React, { useContext, useEffect, useState } from "react";
import "../../Style/createstyle.scss";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Grid, Stack, Box, TextField, Typography, Button } from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
//Src
import { AuthContext } from "../../Context/AuthContext";
import {
  CREATE_WORKINGBASE,
  UPDATE_WORKINGBASE,
} from "../../Schema/WorkingBase";

export default function CreateWorkingBase({
  open,
  handleClose,
  dialogTitle,
  editData,
  setRefetch,
}) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createWorkingBase, { data, error }] = useMutation(CREATE_WORKINGBASE, {
    onCompleted: ({ createWorkingBase }) => {
      // console.log(createWorkingBase);
      setLoading(false);
      if (createWorkingBase?.success === true) {
        setAlert(true, "success", createWorkingBase?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createWorkingBase?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const [updateWorkingBase] = useMutation(UPDATE_WORKINGBASE, {
    onCompleted: ({ updateWorkingBase }) => {
      // console.log(updateWorkingBase);
      setLoading(false);
      if (updateWorkingBase?.success === true) {
        setAlert(true, "success", updateWorkingBase?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", updateWorkingBase?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CreateWorkingBase = Yup.object().shape({
    workingBaseName: Yup.string().required("require!"),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      workingBaseName: "",
      remark: "",
    },

    validationSchema: CreateWorkingBase,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      // console.log("dialogTitle:::", dialogTitle);
      setLoading(true);
      if (dialogTitle !== "Create") {
        updateWorkingBase({
          variables: {
            id: editData?._id,
            input: {
              ...values,
            },
          },
        });
      } else {
        createWorkingBase({
          variables: {
            input: {
              ...values,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  // console.log(editData)

  useEffect(() => {
    if (editData) {
      setFieldValue("workingBaseName", editData?.workingBaseName);
      setFieldValue(
        "remark",
        editData?.remark === null ? "" : editData?.remark
      );
    }
  }, [editData]);

  return (
    <Dialog open={open} className="create-container">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {dialogTitle} Working base
            </Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <CloseIcon className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography className="field-title">Working base</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder="postions"
                  {...getFieldProps("workingBaseName")}
                  error={Boolean(
                    touched.workingBaseName && errors.workingBaseName
                  )}
                  helperText={touched.workingBaseName && errors.workingBaseName}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">Remark</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>

      <DialogActions>
        <Stack direction="row" spacing={4} className="action-container">
          <Button className="btn-cencel" fullWidth onClick={handleClose}>
            Cencel
          </Button>

          {loading ? (
            <Button className="btn-create" fullWidth>
              Loading...
            </Button>
          ) : (
            <Button className="btn-create" fullWidth onClick={handleSubmit}>
              {dialogTitle}
            </Button>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
